import Swiper, { Navigation } from "swiper"
Swiper.use([Navigation])

export default new (class CategoryBrandsCarousel {
    constructor() {
        this.handler()
    }

    handler() {
        document.addEventListener("DOMContentLoaded", () => {
            this.init()
        })
    }

    init() {
        document.querySelectorAll(`.carousel-category-brands`).forEach((item) => {
            if (item.classList.contains('swiper-initialized')) return;
            new Swiper(item, {
                slidesPerView: 'auto',
                spaceBetween: 0,
                navigation: {
                    nextEl: item.closest('.slider-category-brands ').querySelector(`.carousel-category-brands-next`),
                    prevEl: item.closest('.slider-category-brands ').querySelector(`.carousel-category-brands-prev`),
                },
                centerInsufficientSlides: true,
            })
        });
    }
})()
